import { z } from 'zod';
/*
 * Innhold — the content agents' approval queue (GET/PATCH /social/drafts,
 * POST /social/runs). Nothing here posts anywhere: a draft is text, a list of
 * library file ids and the reviewer's verdict, waiting for a human.
 */
const ok = z.literal(true);
export const socialReviewSchema = z.object({
    pass: z.boolean(),
    scores: z.object({ voice: z.number(), claims: z.number(), hook: z.number(), fit: z.number() }),
    issues: z.array(z.object({ severity: z.enum(['block', 'fix', 'note']), problem: z.string(), fix: z.string() })),
    summary: z.string(),
});
export const socialDraftSchema = z.object({
    id: z.number(),
    runId: z.number().nullable(),
    pillar: z.string(),
    format: z.string(),
    platforms: z.array(z.string()),
    plannedFor: z.string().nullable(),
    brief: z.string().nullable(),
    caption: z.string(),
    hashtags: z.array(z.string()).nullable(),
    slides: z
        .array(z.object({ assetId: z.string().nullable(), text: z.string().nullable() }))
        .nullable(),
    missingVisual: z.string().nullable(),
    rationale: z.string().nullable(),
    review: socialReviewSchema.nullable(),
    reviewPassed: z.boolean().nullable(),
    attempts: z.number(),
    status: z.enum(['pending', 'approved', 'rejected']),
    editedCaption: z.string().nullable(),
    decisionReason: z.string().nullable(),
    decidedBy: z.string().nullable(),
    decidedAt: z.string().nullable(),
    createdAt: z.string(),
});
export const socialAssetSchema = z.object({
    id: z.string(),
    type: z.string(),
    category: z.string().nullable(),
    description: z.string().nullable(),
    people: z.string().nullable(),
    roles: z.string().nullable(),
    orientation: z.string().nullable(),
    quality: z.number().nullable(),
    takenOn: z.string().nullable(),
    textInImage: z.string().nullable(),
    label: z.string().nullable(),
    healthMentioned: z.boolean(),
});
export const socialRunSchema = z.object({
    id: z.number(),
    status: z.string(),
    triggeredBy: z.string().nullable(),
    weekOf: z.string().nullable(),
    plan: z.object({ notes: z.string().optional() }).passthrough().nullable(),
    usage: z.record(z.number()).nullable(),
    error: z.string().nullable(),
    startedAt: z.string(),
    finishedAt: z.string().nullable(),
});
export const socialDraftsResponse = z.object({
    ok,
    agentsConfigured: z.boolean(),
    library: z.object({ total: z.number(), usable: z.number() }),
    counts: z.record(z.number()),
    lastRun: socialRunSchema.nullable(),
    drafts: z.array(socialDraftSchema),
    assets: z.record(socialAssetSchema),
});
export const socialDecideResponse = z.object({ ok, draft: socialDraftSchema });
export const socialRunResponse = z.object({
    ok: z.boolean(),
    started: z.boolean(),
    reason: z.string().optional(),
});
//# sourceMappingURL=social.js.map